import React from 'react';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {ReactComponent as AreaChartIcon} from 'images/icon/filled-area-chart.svg';
import {ReactComponent as BarChartIcon} from 'images/icon/bar-chart.svg';
import {ReactComponent as DashedLineIcon} from 'images/icon/dashed-line.svg';
import './CoachingSkillVelocityChartLegend.styl';
import CoachingContentDetail from 'records/CoachingContentDetail';
import User from 'records/User';
import Skill from 'records/Skill';
import {skillColorByIdx} from 'utils/skill-color-by-idx';

interface CoachingPlanOverviewLegendInterface {
  recipient: User;
  skill: Skill;
  contentDetail: CoachingContentDetail;
  graphType: 'progress' | 'goals';
}

export default class CoachingPlanOverviewLegend extends React.Component<CoachingPlanOverviewLegendInterface> {
  render() {
    const {recipient, skill, contentDetail, graphType} = this.props;
    const skillName = skill ? skill.skill : contentDetail.custom;

    if (graphType === 'goals') {
      return (
        <ul className="coaching-skill-velocity-chart-legend kpi-legend">
          <li>
            <svg viewBox={'0 0 20 20'}>
              <path d={'M 0,10 H 20'} fill="none" stroke={skillColorByIdx(0)} strokeWidth={4} />
            </svg>
            <GenericTooltip
              hoverBehavior
              delay={500}
              tooltip={'A solid line connecting the KPI values which have been entered so far'}>
              KPI Observations
            </GenericTooltip>
          </li>
          <li>
            <svg viewBox={'0 0 20 20'}>
              <path
                d={'M 0,10 H 20'}
                fill="none"
                stroke={skillColorByIdx(0)}
                strokeDasharray={'8 4'}
                strokeWidth={4}
              />
            </svg>
            <GenericTooltip
              hoverBehavior
              delay={500}
              tooltip="A dashed line showing the KPI's target amount">
              KPI Target
            </GenericTooltip>
          </li>
          <li>
            <svg viewBox={'0 0 20 20'}>
              <rect width={20} height={20} fill="#CFC3C933" stroke="#CFC3C9" strokeWidth={1} />
            </svg>
            <GenericTooltip
              hoverBehavior
              delay={500}
              tooltip={`A shaded section containing entries before the plan's start date`}>
              Before Plan Start
            </GenericTooltip>
          </li>
        </ul>
      );
    }

    return (
      <ul className="coaching-skill-velocity-chart-legend">
        <li>
          <BarChartIcon />
          <GenericTooltip
            hoverBehavior
            delay={500}
            tooltip={
              skillName &&
              recipient &&
              `A bar series with each bar representing a meeting with ${recipient.firstName}.  The size of the bar represents their average score for ${skillName} that they received during that meeting.`
            }>
            Meeting scores
          </GenericTooltip>
        </li>
        <li>
          <AreaChartIcon />
          <GenericTooltip
            hoverBehavior
            delay={500}
            tooltip={
              skillName &&
              recipient &&
              `An area chart representing averages of scorecards related to ${skillName} that ${recipient.firstName} has received over time.`
            }>
            Scorecard skill ratings
          </GenericTooltip>
        </li>
        <li>
          <DashedLineIcon />
          <GenericTooltip
            hoverBehavior
            delay={500}
            tooltip={
              skillName &&
              recipient &&
              contentDetail &&
              `The general trend line that ${recipient.firstName}'s average scores for ${skillName} need to follow in order to meet their goal of ${contentDetail.skillGoal} for this coaching plan.`
            }>
            Goal trend line
          </GenericTooltip>
        </li>
      </ul>
    );
  }
}
